export default __webpack_public_path__ + "static/media/vc2.8a5434c4.jpg";